import { useAppStore } from '@/stores/AppStore'
import { BFAlbum, BFPicture, MyBFAlbum } from '@/type/BFAlbum'
import http from '@/services/http'

export interface BFRepository {
  fetchBFAlbum: () => Promise<BFAlbum[]>
  fetchAlbumPicture: (album_id: Number) => Promise<BFPicture[]>
  fetchTags: () => Promise<any> // Not use this endpoint yet
  fetchMyAlbums: () => Promise<MyBFAlbum[]>
  fetchMyAlbumPictures: (album_id: Number) => Promise<BFPicture[]>
}

export function useBFRepository(clinic_uuid: string): BFRepository {
  const appStore = useAppStore()

  async function fetchBFAlbum(): Promise<BFAlbum[]> {
    const response = await http.get(
      `${appStore.url}/api/v1/crm/line-app/p/bf-showcase/`,
      {
        params: {
          c: clinic_uuid,
          liffId: appStore.liffId,
        },
      },
    )
    return response.data
  }

  async function fetchAlbumPicture(album_id: Number): Promise<BFPicture[]> {
    const response = await http.get(
      `${appStore.url}/api/v1/crm/line-app/p/bf-showcase/item/`,
      {
        params: {
          c: clinic_uuid,
          album_id: album_id,
        },
      },
    )
    return response.data
  }

  async function fetchTags() {
    const response = await http.get(
      `${appStore.url}/api/v1/crm/line-app/p/bf-showcase/tag/?c=${clinic_uuid}`,
    )
    return response.data
  }

  // "อัลบั้มรูปของฉัน" — เฉพาะ album ที่คนไข้เจ้าของ (ตัวเอง) ถูกเปิดให้ดู (LMP-5541)
  // ต่างจาก fetchBFAlbum/fetchAlbumPicture ที่เป็น Showcase สาธารณะ (ไม่ scope ตาม patient)
  async function fetchMyAlbums(): Promise<MyBFAlbum[]> {
    const response = await http.get(
      `${appStore.url}/api/v1/crm/line-app/p/patient/bf-album/`,
      {
        params: {
          clinic_uuid: clinic_uuid,
          line_user_id: appStore.userProfile.userId,
          liff_id: appStore.liffId,
        },
      },
    )
    return response.data.data ?? []
  }

  async function fetchMyAlbumPictures(album_id: Number): Promise<BFPicture[]> {
    const response = await http.get(
      `${appStore.url}/api/v1/crm/line-app/p/patient/bf-album/item/`,
      {
        params: {
          clinic_uuid: clinic_uuid,
          line_user_id: appStore.userProfile.userId,
          liff_id: appStore.liffId,
          album_id: album_id,
        },
      },
    )
    return response.data.data ?? []
  }

  return {
    fetchBFAlbum,
    fetchAlbumPicture,
    fetchTags,
    fetchMyAlbums,
    fetchMyAlbumPictures,
  }
}
